<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="sale.customer.name" :header="dateDiff" :subtext="sale.company.name" :colspan="(sale.pivot.transaction) ? 1 : 2" @select="select" />
		<LayoutTableCommonPartRaw class="font-code lh-xs align-top text-end" v-if="sale.pivot.transaction">
			<div class="text-muted text-lg d-inline" v-tooltip:left="`<b>Comisión:</b><br />${sale.pivot.transaction.amount} ${sale.currency}`"><i class="bi bi-coin"></i></div>
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartRaw class="font-code lh-xs align-top text-end" width="20%" @select="select">
			<span class="d-inline-block text-nowrap">{{ vueNumberFormat(sale.amount, { suffix: ` ${sale.currency}`, precision: 2 }) }}</span>
		</LayoutTableCommonPartRaw>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed, getCurrentInstance } from 'vue';
	import moment from 'moment';

	export default {
		emits: ['select'],
		props: {
			sale: Object,
			selectable: Boolean
		},
		setup(props, { emit }) {
			const instance = getCurrentInstance();
			const dateDiff = computed(() => moment(props.sale.created_at).fromNow());
			const dateFormatted = computed(() => moment(props.sale.created_at).format('LL'));
			const select = () => {
				console.log('a', props.selectable);
				if(props.selectable) emit('select', props.sale);
			}

			return { dateDiff, dateFormatted, select };
		}
	}
</script>